import type { ISubItemsResponse } from './types';

/* eslint-disable max-len */
export default function (
  defaultLocale: string,
  sections: {
    title: any,
    enabled?: boolean,
    countries?: string[],
    items: {
      title?: any;
      routes: { title: any; path: string; enabled?: boolean; countries?: string[], }[];
      enabled?: boolean;
      countries?: string[],
    }[] }[],
): ISubItemsResponse[] {
  return sections
    .filter((route) => route?.countries?.includes(defaultLocale) || !route.countries)
    .filter((route) => route.enabled || route.enabled !== false)
    .map((route) => ({
      ...route,
      items: route.items
        .filter((item) => item?.countries?.includes(defaultLocale) || !item?.countries)
        .filter((item) => item.enabled || item.enabled !== false)
        .map((item) => ({
          ...item,
          items: item?.routes?.filter((subItemRoute) => subItemRoute?.countries?.includes(defaultLocale) || !route.countries)
            ?.filter((subItemRoute) => subItemRoute.enabled || subItemRoute.enabled !== false),
        })),
    }));
}
